var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-loader"},[(_vm.loading)?_c('div',{staticClass:"loader-container"},[_c('div',{staticClass:"loader"}),_c('p',{class:{ lod: _vm.lightOnDark }},[_vm._v(_vm._s(_vm.content))])]):_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }